import styled from "styled-components";
import { sharedStyles } from "../Shared/Shared.styled";

const styles = {
  StyledButton: styled.div`
    ${sharedStyles}
    background: ${({ theme }) => theme.colors.neutral.white};
    border: 2px solid ${({ theme }) => theme.colors.primary.blue800};

    &:hover {
      background-color: ${({ theme }) => theme.colors.neutral.grey200};
    }
  `,
  ButtonLabel: styled.span`
    color: ${({ theme }) => theme.colors.primary.blue800};
  `,
};

export default styles;
